import { useQuery } from '@tanstack/react-query';
import getArea from 'Api/area/getArea';
import getAreaResponse from './model/response/getAreaResponse';

const useGetArea = () => {
  return useQuery({
    queryKey: ['area'],
    queryFn: async () => {
      const response = await getArea();

      return getAreaResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetArea;
